// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3NNoH","title":"ClientInsurance_title__7wTjW","itemText":"ClientInsurance_itemText__rtgAq"};